import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, TransformWithLVS } from '@goparrot/common';
import { PromotionAmountTypeEnum } from '@goparrot/promotions-sdk';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { ArrayNotEmpty, IsArray, IsBoolean, IsDate, IsEnum, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { EarnRuleTypeEnum, LoyaltyProgramExposeGroupEnum, LoyaltyProgramTypeEnum } from '../interface';
import { EarnRuleMaxCount } from '../validator';
import { PutAbstractEarnRuleDto } from './PutAbstractEarnRuleDto';
import { PutEarnRuleCategoryDto } from './PutEarnRuleCategoryDto';
import { PutEarnRuleItemDto } from './PutEarnRuleItemDto';
import { PutEarnRuleSignupDto } from './PutEarnRuleSignupDto';
import { PutEarnRuleSpendDto } from './PutEarnRuleSpendDto';
import { PutEarnRuleVisitDto } from './PutEarnRuleVisitDto';
import { PutExpirationPolicyDto } from './PutExpirationPolicyDto';
import { PutSpendRuleDto } from './PutSpendRuleDto';
import { PutTerminologyDto } from './PutTerminologyDto';
export class PutLoyaltyProgramDto {
    constructor() {
        this.isEditable = true;
        this.type = LoyaltyProgramTypeEnum.REGULAR;
    }
}
__decorate([
    ApiProperty({ type: () => Boolean, example: true }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsNotEmpty({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], PutLoyaltyProgramDto.prototype, "isActive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, default: true }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsBoolean({ groups: [LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    __metadata("design:type", Boolean)
], PutLoyaltyProgramDto.prototype, "isEditable", void 0);
__decorate([
    ApiProperty({ type: () => String, isArray: true, example: ['WESTVILLE_VEST', 'WESTVILLE_CHELSEA'] }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsString({ always: true, each: true }),
    IsNotEmpty({ always: true }),
    IsArray({ always: true }),
    __metadata("design:type", Array)
], PutLoyaltyProgramDto.prototype, "locations", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, example: new Date(new Date().getTime() - 24 * 60 * 60 * 1000) }),
    TransformWithLVS(({ value }) => (value instanceof Date ? value.toISOString() : value), { toPlainOnly: true }),
    TransformWithLVS(({ value }) => (typeof value === 'string' ? new Date(value) : value), { toClassOnly: true }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsDate({ always: true }),
    __metadata("design:type", Date)
], PutLoyaltyProgramDto.prototype, "startDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Date, example: new Date(new Date().getTime() + 24 * 60 * 60 * 1000) }),
    TransformWithLVS(({ value }) => (value instanceof Date ? value.toISOString() : value), { toPlainOnly: true }),
    TransformWithLVS(({ value }) => (typeof value === 'string' ? new Date(value) : value), { toClassOnly: true }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    IsDate({ always: true }),
    __metadata("design:type", Date)
], PutLoyaltyProgramDto.prototype, "endDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PutExpirationPolicyDto }),
    Type(() => PutExpirationPolicyDto),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    IsOptional({ always: true }),
    ValidateNested({ always: true }),
    __metadata("design:type", PutExpirationPolicyDto)
], PutLoyaltyProgramDto.prototype, "expirationPolicy", void 0);
__decorate([
    ApiProperty({ enum: LoyaltyProgramTypeEnum, default: LoyaltyProgramTypeEnum.REGULAR }),
    Expose({
        groups: [
            LoyaltyProgramExposeGroupEnum.READ,
            LoyaltyProgramExposeGroupEnum.PUT,
            LoyaltyProgramExposeGroupEnum.CREATE,
            LoyaltyProgramExposeGroupEnum.LIST,
        ],
    }),
    IsOptional({ groups: [LoyaltyProgramExposeGroupEnum.CREATE, LoyaltyProgramExposeGroupEnum.LIST] }),
    IsNotEmpty({ always: true }),
    IsEnum(LoyaltyProgramTypeEnum, { always: true }),
    __metadata("design:type", String)
], PutLoyaltyProgramDto.prototype, "type", void 0);
__decorate([
    ApiProperty({
        isArray: true,
        example: [
            {
                type: EarnRuleTypeEnum.SPEND,
                money: 10,
                points: 10,
            },
        ],
    }),
    Type(() => PutAbstractEarnRuleDto, {
        discriminator: {
            property: 'type',
            subTypes: [
                { value: PutEarnRuleSignupDto, name: EarnRuleTypeEnum.SIGNUP },
                { value: PutEarnRuleVisitDto, name: EarnRuleTypeEnum.VISIT },
                { value: PutEarnRuleSpendDto, name: EarnRuleTypeEnum.SPEND },
                { value: PutEarnRuleItemDto, name: EarnRuleTypeEnum.ITEM },
                { value: PutEarnRuleCategoryDto, name: EarnRuleTypeEnum.CATEGORY },
            ],
        },
        keepDiscriminatorProperty: true,
    }),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    ArrayNotEmpty({ always: true }),
    IsArray({ always: true }),
    EarnRuleMaxCount({ type: EarnRuleTypeEnum.SIGNUP, quota: 1 }, { always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], PutLoyaltyProgramDto.prototype, "earnRules", void 0);
__decorate([
    ApiProperty({
        isArray: true,
        example: [
            {
                points: 10,
                promotion: {
                    discount: {
                        type: PromotionAmountTypeEnum.FIXED,
                        value: 1,
                    },
                },
            },
        ],
    }),
    Type(() => PutSpendRuleDto),
    Expose({ groups: [LoyaltyProgramExposeGroupEnum.READ, LoyaltyProgramExposeGroupEnum.PUT, LoyaltyProgramExposeGroupEnum.CREATE] }),
    ArrayNotEmpty({ always: true }),
    IsArray({ always: true }),
    ValidateNested({ always: true, each: true }),
    __metadata("design:type", Array)
], PutLoyaltyProgramDto.prototype, "spendRules", void 0);
__decorate([
    ApiProperty({ type: () => PutTerminologyDto }),
    Expose({
        groups: [
            LoyaltyProgramExposeGroupEnum.READ,
            LoyaltyProgramExposeGroupEnum.PUT,
            LoyaltyProgramExposeGroupEnum.CREATE,
            LoyaltyProgramExposeGroupEnum.PREVIEW,
        ],
    }),
    IsNotEmptyObjectWithLVS({ always: true }),
    ValidateNested({ always: true }),
    Type(() => PutTerminologyDto),
    __metadata("design:type", PutTerminologyDto)
], PutLoyaltyProgramDto.prototype, "terminology", void 0);
//# sourceMappingURL=PutLoyaltyProgramDto.js.map